var _circle, _g, _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import React from 'react';
const SvgComponent = props => /*#__PURE__*/React.createElement("svg", _extends({
  height: 26,
  viewBox: "0 0 26 26",
  width: 26
}, props), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
  cx: 13,
  cy: 13,
  fill: "#dd5725",
  r: 13
})), _g || (_g = /*#__PURE__*/React.createElement("g", {
  fill: "#fff"
}, /*#__PURE__*/React.createElement("path", {
  d: "m324.574 304.4a2.424 2.424 0 1 0 2.426 2.427 2.426 2.426 0 0 0 -2.426-2.427zm0 3.635a1.212 1.212 0 1 1 1.212-1.212 1.213 1.213 0 0 1 -1.212 1.215z",
  transform: "translate(-307.089 -289.292)"
}), /*#__PURE__*/React.createElement("path", {
  d: "m104.071 304.4a2.424 2.424 0 1 0 2.424 2.423 2.426 2.426 0 0 0 -2.424-2.423zm0 3.635a1.212 1.212 0 1 1 1.212-1.212 1.213 1.213 0 0 1 -1.212 1.215z",
  transform: "translate(-94.865 -289.292)"
}), /*#__PURE__*/React.createElement("path", {
  d: "m334.488 111.124a.606.606 0 0 0 -.541-.334h-3.191v1.21h2.817l1.65 3.281 1.083-.544z",
  transform: "translate(-315.371 -102.949)"
}), /*#__PURE__*/React.createElement("path", {
  d: "m11.084 16.949h4.584v1.212h-4.584z"
}), /*#__PURE__*/React.createElement("path", {
  d: "m48.421 353.345h-2.1a.606.606 0 0 0 0 1.212h2.1a.606.606 0 1 0 0-1.212z",
  transform: "translate(-41.033 -336.396)"
}), /*#__PURE__*/React.createElement("path", {
  d: "m63.1 85.137-1.194-1.537a.605.605 0 0 0 -.478-.234h-4.4v-4.239a.606.606 0 0 0 -.606-.606h-10.1a.606.606 0 1 0 0 1.212h9.492v4.241a.606.606 0 0 0 .606.606h4.712l.882 1.137v3.125h-1.677a.606.606 0 1 0 0 1.212h2.282a.606.606 0 0 0 .606-.606v-3.939a.607.607 0 0 0 -.125-.372z",
  transform: "translate(-41.033 -71.892)"
}), /*#__PURE__*/React.createElement("path", {
  d: "m29.746 271.6h-2.787a.606.606 0 0 0 0 1.212h2.787a.606.606 0 0 0 0-1.212z",
  transform: "translate(-22.398 -257.718)"
}), /*#__PURE__*/React.createElement("path", {
  d: "m5.776 208.134h-5.17a.606.606 0 0 0 0 1.212h5.17a.606.606 0 0 0 0-1.212z",
  transform: "translate(2.965 -196.638)"
}), /*#__PURE__*/React.createElement("path", {
  d: "m32.129 144.672h-5.17a.606.606 0 1 0 0 1.212h5.17a.606.606 0 1 0 0-1.212z",
  transform: "translate(-22.398 -135.559)"
}))), _path || (_path = /*#__PURE__*/React.createElement("path", {
  d: "m18.5 4.5-11 17",
  fill: "none",
  stroke: "#fff",
  strokeLinecap: "round",
  strokeWidth: 2
})));
export default __webpack_public_path__ + "static/media/nonservicable.8c3cc1b4.svg";
export { SvgComponent as ReactComponent };